import DeudaCrud from './DeudaCrud'
export {DeudaCrud}
export default DeudaCrud
